import cx from "clsx";
import { FileHandle } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Image from "next/image";
import React from "react";
import { MdPerson } from "react-icons/md";

import { FRAME, FrameKey } from "./config";
import styles from "./index.module.scss";

import SecondaryFileViewer from "@/modules/kreate-components/components/SecondaryFileViewer";

type Length = `${number}${"px"}`;

type Props = {
  className?: string;
  style?: React.CSSProperties;
  avatar: FileHandle | null | undefined;
  size: Length;
  frame: FrameKey;
};

export default function GalleryAvatarViewer$WithCustomFrame({
  className,
  style,
  avatar,
  size,
  frame,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <div
        className={styles.content}
        style={
          {
            "--size": size,
            "--frame-osize": FRAME[frame].osize,
            "--frame-isize": FRAME[frame].isize,
          } as React.CSSProperties
        }
      >
        <div className={styles.avatarContainer}>
          {avatar ? (
            <SecondaryFileViewer
              file={avatar}
              thumbnailFile={undefined}
              sizes={size}
              objectFit="cover"
              fill
            />
          ) : (
            <Flex.Row
              className={styles.noAvatar}
              justifyContent="center"
              alignItems="center"
            >
              <MdPerson />
            </Flex.Row>
          )}
        </div>
        <Image src={FRAME[frame].src} alt="" fill />
      </div>
    </div>
  );
}
